export enum TemperatureByVehicleListColumn {
  VehicleIds = 'vehicleIds',
  Groups = 'groups',
  Depot = 'depot',
}
